"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Link } from "@/components/common/Link";
import { ChevronRight, Phone } from "lucide-react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="hero" ref={ref} className="relative min-h-screen flex items-center justify-center overflow-hidden bg-dark-section">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/hero_luxury_transport.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/hero_luxury_transport.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1549622/img/hero_luxury_transport.png-wvc-sizes" alt="Luxury Black Car Service Los Angeles" className="w-full h-full object-cover animate-zoom-in" loading="eager" decoding="async" />
        <div className="surface-overlay" />
      </div>

      {}
      <div className="relative z-10 max-w-5xl mx-auto px-6 text-center">
        <div className={`transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {}
          <div className="glass-effect p-8 md:p-12 inline-block">
            <span className="inline-block text-secondary font-semibold tracking-[0.2em] uppercase text-sm mb-4 animate-reveal">
              Premium Mobility Solutions
            </span>
            
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-display font-bold text-white mb-6 leading-tight">
              PHOENIX ENTERPRISE <span className="text-secondary">TCP</span>
            </h1>
            
            <p className="text-lg md:text-xl text-white/90 max-w-2xl mx-auto mb-10 font-sans leading-relaxed">
              Experience the pinnacle of professional chauffeur services in Los Angeles. 
              Luxury Black Car & SUV transfers tailored for executives, VIPs, and elite travelers.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link to="/ReservationsPage" className="btn-primary w-full sm:w-auto group">
                Book Your Ride
                <ChevronRight className="ml-2 h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
              
              <Link to="/FleetPage" className="btn-secondary w-full sm:w-auto text-white border-white/30 hover:border-secondary">
                Explore Our Fleet
              </Link>
            </div>

            <div className="mt-8 flex items-center justify-center gap-6 text-white/70 text-sm border-t border-white/10 pt-8">
              <div className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-secondary" />
                <span>323-492-6292</span>
              </div>
              <div className="hidden sm:block w-px h-4 bg-white/20" />
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-lg bg-green-500" />
                <span>Available 24/7</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes zoom-in {
          0% {
            transform: scale(1);
          }
          100% {
            transform: scale(1.1);
          }
        }

        .animate-zoom-in {
          animation: zoom-in 20s ease-out forwards;
        }

        @media (prefers-reduced-motion: reduce) {
          .animate-zoom-in {
            animation: none;
            transform: scale(1);
          }
        }
      `}</style>
    </section>;
}